<template>
  <div class="navbar">

    <d-breadcrumb id="breadcrumb-container"
                  class="breadcrumb-container" />

    <div class="right-menu">
      当前用户名：{{this.userInfo.userLoginName}} &nbsp;&nbsp;
      <el-button type="warning"
                 size="mini"
                 @click="logout">退出</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
      <template v-if="device!=='mobile'">
        <!-- <search id="header-search" class="right-menu-item" /> -->

        <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->

        <!-- <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->
        <!--
        <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
        <!--
        <el-button type="warning"
                   size="mini"
                   @click="logout">退出</el-button>&nbsp;&nbsp;&nbsp;&nbsp; -->
      </template>

      <!-- <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img :src="Portrait" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>

      </el-dropdown> -->
    </div>
  </div>
</template>

<script>
import {
  removeAccessToken,
  removeUserInfo,
  getUserInfo,
} from '@/utils/auth';
import { mapGetters } from 'vuex';
import Portrait from '@/assets/portrait.jpg';
// import Hamburger from '@/components/Hamburger'
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import Search from '@/components/HeaderSearch'

export default {
  data() {
    return {
      Portrait: `${Portrait}?${+new Date()}`,
      userInfo: {},
    };
  },
  components: {
    // Hamburger,
    // ErrorLog,
    // Screenfull,
    // SizeSelect,
    // Search
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
    ]),
  },
  created() {
    this.userInfo = getUserInfo();
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout() {
      //   const that = this;
      removeAccessToken();
      removeUserInfo();
      const url = `${window.location.protocol}//${window.location.host}`;
      window.location.href = url;
      //   this.$store.dispatch('user/logout').then(() => {
      //     this.$message({
      //       message: '退出成功',
      //       type: 'success',
      //     });
      //     // that.$router.push('/login')
      //     // that.$router.push(`/login?redirect=${that.$route.fullPath}`);
      //   });
    },
    homepage() {
      const url = `${window.location.protocol}//${window.location.host}`;
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue